import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// ci: OIDC deploy -- Workloads-Dev v2
@Component({ 
  selector: 'app-root', 
  standalone: true,
  imports: [RouterOutlet],
  template: `  
    <div class="auth-app">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`    
    .auth-app { 
      min-height: 100vh;  
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    }
  `]
}) 
export class AppComponent {
  title = 'auth-ui';
}
